// Generated by purs version 0.13.8
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_FoldableWithIndex = require("../Data.FoldableWithIndex/index.js");
var Data_Function = require("../Data.Function/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_HeytingAlgebra = require("../Data.HeytingAlgebra/index.js");
var Data_List = require("../Data.List/index.js");
var Data_List_Types = require("../Data.List.Types/index.js");
var Data_Map_Internal = require("../Data.Map.Internal/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Set = require("../Data.Set/index.js");
var Data_Tuple = require("../Data.Tuple/index.js");
var Extra_Math = require("../Extra.Math/index.js");
var loopUntil = function (stop) {
    return function (next) {
        return function (seed) {
            var succeeded = stop(seed);
            if (succeeded) {
                return new Data_Tuple.Tuple(seed, succeeded);
            };
            return Data_Maybe.maybe(new Data_Tuple.Tuple(seed, false))(loopUntil(stop)(next))(next(seed));
        };
    };
};
var loop = function (next) {
    return function (seed) {
        return Data_Maybe.maybe(seed)(loop(next))(next(seed));
    };
};
var floodFillStep = function (dictOrd) {
    return function (expand) {
        return function (v) {
            return Control_Bind.bind(Data_Maybe.bindMaybe)(Data_List.uncons(v.frontier))(function (v1) {
                var newVertices = Data_Array.filter((function () {
                    var $33 = Data_HeytingAlgebra.not(Data_HeytingAlgebra.heytingAlgebraBoolean);
                    var $34 = Data_Function.flip(Data_Set.member(dictOrd))(v.expanded);
                    return function ($35) {
                        return $33($34($35));
                    };
                })())(expand(v1.head));
                var frontier$prime = Data_Foldable.foldr(Data_Foldable.foldableArray)(Data_List_Types.Cons.create)(v1.tail)(newVertices);
                var expanded$prime = Data_Set.insert(dictOrd)(v1.head)(v.expanded);
                return Control_Applicative.pure(Data_Maybe.applicativeMaybe)({
                    frontier: frontier$prime,
                    expanded: expanded$prime
                });
            });
        };
    };
};
var reachable = function (dictOrd) {
    return function (start) {
        return function (end) {
            return function (expand) {
                return Data_Tuple.snd(Data_Function.flip(loopUntil(function (v) {
                    return Data_Foldable.elem(Data_List_Types.foldableList)(dictOrd.Eq0())(end)(v.frontier);
                }))({
                    frontier: Data_List.singleton(start),
                    expanded: Data_Set.empty
                })(floodFillStep(dictOrd)(expand)));
            };
        };
    };
};
var floodFill = function (dictOrd) {
    return function (start) {
        return function (expand) {
            return (function (v) {
                return v.expanded;
            })(Data_Function.flip(loop)({
                frontier: Data_List.singleton(start),
                expanded: Data_Set.empty
            })(floodFillStep(dictOrd)(expand)));
        };
    };
};
var flatten = function (m) {
    return Data_FoldableWithIndex.foldlWithIndex(Data_Map_Internal.foldableWithIndexMap)(function (k) {
        return function (a) {
            return function (v) {
                return Data_Array.cons({
                    k: k,
                    v: v
                })(a);
            };
        };
    })([  ])(m);
};
var distanceMapStep = function (dictOrd) {
    return function (expand) {
        return function (v) {
            return Control_Bind.bind(Data_Maybe.bindMaybe)(Data_Array.uncons(v.frontier))(function (v1) {
                var newNodes = Data_Functor.map(Data_Functor.functorArray)(function (w) {
                    return {
                        v: w,
                        d: v1.head.d + 1 | 0
                    };
                })(Data_Array.filter((function () {
                    var $36 = Data_HeytingAlgebra.not(Data_HeytingAlgebra.heytingAlgebraBoolean);
                    var $37 = Data_Function.flip(Data_Foldable.elem(Data_Foldable.foldableArray)(dictOrd.Eq0()))(Data_Functor.mapFlipped(Data_Functor.functorArray)(v.frontier)(function (v3) {
                        return v3.v;
                    }));
                    return function ($38) {
                        return $36($37($38));
                    };
                })())(Data_Array.filter((function () {
                    var $39 = Data_HeytingAlgebra.not(Data_HeytingAlgebra.heytingAlgebraBoolean);
                    var $40 = Data_Function.flip(Data_Map_Internal.member(dictOrd))(v.expanded);
                    return function ($41) {
                        return $39($40($41));
                    };
                })())(expand(v1.head.v))));
                var frontier$prime = Data_Array.sortBy(Data_Ord.comparing(Data_Ord.ordInt)(function (v3) {
                    return v3.d;
                }))(Data_Foldable.foldr(Data_Foldable.foldableArray)(Data_Array.cons)(v1.tail)(newNodes));
                var expanded$prime = Data_Map_Internal.insert(dictOrd)(v1.head.v)(v1.head.d)(v.expanded);
                return Control_Applicative.pure(Data_Maybe.applicativeMaybe)({
                    frontier: frontier$prime,
                    expanded: expanded$prime
                });
            });
        };
    };
};
var distanceMap = function (start) {
    return function (expand) {
        return (function (v) {
            return v.expanded;
        })(Data_Function.flip(loop)({
            frontier: [ {
                v: start,
                d: 0
            } ],
            expanded: Data_Map_Internal.empty
        })(distanceMapStep(Extra_Math.ordVector(Data_Ord.ordInt))(expand)));
    };
};
module.exports = {
    floodFill: floodFill,
    reachable: reachable,
    floodFillStep: floodFillStep,
    distanceMap: distanceMap,
    flatten: flatten,
    distanceMapStep: distanceMapStep,
    loop: loop,
    loopUntil: loopUntil
};
